export default __webpack_public_path__ + "static/media/warning--polar-bear-crossing--g1.83f48f13.png";